module.exports = __webpack_public_path__ + "static/media/nav-icon-slack.a128c986.svg";